import { useEffect, useState, useRef } from 'react';
import { Divider } from 'antd';
import { LuNotebook } from "react-icons/lu";
import { TbFileSmile } from "react-icons/tb";
import { IoAtOutline } from "react-icons/io5";
import { HiOutlinePhone } from "react-icons/hi2";
import { db, auth } from '../firebase';
import { collection, query, where, onSnapshot } from 'firebase/firestore';
import { NoResultBox } from '../functions/ui';
import { addRippleEffect } from '../functions/classes';
import '../webapp.css';
import { onAuthStateChanged } from 'firebase/auth';
import { useNavigate } from 'react-router-dom';
import { PiChartLineBold } from 'react-icons/pi';

const Staff = () => {
  const [staff, setStaff] = useState([]);
  const [contextMenu, setContextMenu] = useState({ visible: false, x: 0, y: 0, staff: null });
  const [loading, setLoading] = useState(true);
  const menuRef = useRef(null);
  const navigate = useNavigate();

  useEffect(() => {
    let unsubscribeAuth;
    let unsubscribeStaff;
    unsubscribeAuth = onAuthStateChanged(auth, (user) => {
      setLoading(true);
      if (!user) {
        setStaff([]);
        setLoading(false);
        return;
      }
      const companyUID = user.uid;
      const q = query(collection(db, 'users'), where('employer', 'array-contains', companyUID));
      unsubscribeStaff = onSnapshot(q, (snap) => {
        setStaff(
          snap.docs.map(doc => ({ id: doc.id, ...doc.data() }))
        );
        setLoading(false);
      }, (error) => {
        setStaff([]);
        setLoading(false);
      });
    });
    return () => {
      if (unsubscribeAuth) unsubscribeAuth();
      if (unsubscribeStaff) unsubscribeStaff();
    };
  }, []);

  const handleContextMenu = (e, staffRow) => {
    e.preventDefault();
    setContextMenu({ visible: true, x: e.clientX, y: e.clientY, staff: staffRow });
  };
  const closeContextMenu = () => setContextMenu({ ...contextMenu, visible: false });

  useEffect(() => {
    function handleClickOutside(event) {
      if (contextMenu.visible && menuRef.current && !menuRef.current.contains(event.target)) {
        setContextMenu({ ...contextMenu, visible: false });
      }
    }
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [contextMenu]);

  useEffect(() => {
    // Highlight the staff sidebar button when this view is mounted
    const staffBtn = document.querySelector('.sidebar a[href="/dashboard/staff"]');
    if (staffBtn) {
      staffBtn.classList.add('active');
    }
    return () => {
      if (staffBtn) staffBtn.classList.remove('active');
    };
  }, []);

  return (
      <div className='dashboard-box'>
        <h2>Staff List</h2>
        <p className='small-text'>Manage staff database</p>
        <Divider className='dash-divider'/>
        {loading ? (
          <p>Loading...</p>
        ) : (
          <div className="second-table-wrapper">
            <div className="table-wrapper">
              <table className="table">
                <thead>
                  <tr>
                    <th><div><LuNotebook className="table-icon icon-grey" /> First name</div></th>
                    <th><div><TbFileSmile className="table-icon icon-blue" /> Last name</div></th>
                    <th><div><IoAtOutline className="table-icon icon-grey" /> Email</div></th>
                    <th><div><HiOutlinePhone className="table-icon icon-yellow" /> Phone</div></th>
                  </tr>
                </thead>
              </table>
              {staff.length > 0 ? (
                <div className="tbody-overflow">
                  <table className="table">
                    <tbody>
                      {staff.map((user) => (
                        <tr key={user.id} onContextMenu={e => { handleContextMenu(e, user); }}>
                          <td>{user.firstName || '-'}</td>
                          <td>{user.lastName || '-'}</td>
                          <td>{user.email || '-'}</td>
                          <td>{user.phone || '-'}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              ) : (
                <div className="error-div">
                  <NoResultBox />
                </div>
              )}
              {contextMenu.visible && (
                <div className="menu-box" style={{top: contextMenu.y, left: contextMenu.x, position: 'fixed'}} ref={menuRef}>
                  <div className='menu-box-div' onClick={e => {
                    addRippleEffect(e);
                    closeContextMenu();
                    navigate('/dashboard/view', { state: { staff: contextMenu.staff } });
                  }}><PiChartLineBold className="profile-menu-icon" /><span>View Shifts</span></div>
                </div>
              )}
            </div>
          </div>
        )}
      </div>
  );
};

export default Staff;
